import { UPDATE_JUNCTURE } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_JUNCTURE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_JUNCTURE.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case UPDATE_JUNCTURE.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
